// app/frontend/entrypoints/application.ts
import "./application.css" // Loads your Tailwind CSS
import { createInertiaApp, router } from '@inertiajs/react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { forceAnalyticsDebug, initializeAnalytics, isAnalyticsDebugEnabled, setAnalyticsDebug, syncAnalyticsDebugFromUrl, trackPageView } from '@/lib/analytics'
import { renderInertiaShell, resolvePageComponent, syncPageCsrfToken, syncPageLocale } from '@/lib/inertia'
import { initializeTheme } from '@/lib/theme'

initializeTheme()

if (typeof window !== 'undefined') {
  if (import.meta.env.DEV) {
    const debugWindow = window as Window & {
      setGaDebug?: (enabled: boolean) => void
      gaDebugEnabled?: () => boolean
    }

    debugWindow.setGaDebug = (enabled: boolean) => setAnalyticsDebug(enabled)
    debugWindow.gaDebugEnabled = () => isAnalyticsDebugEnabled()
  }
}

createInertiaApp({
  resolve: resolvePageComponent,
  async setup({ el, App, props }) {
    const railsEnv = typeof props.initialPage.props.rails_env === 'string' ? props.initialPage.props.rails_env : undefined

    if (railsEnv === 'development') {
      forceAnalyticsDebug(true)
    } else {
      syncAnalyticsDebugFromUrl(window.location.href)
    }

    const ga4Id = typeof props.initialPage.props.ga4_id === 'string' ? props.initialPage.props.ga4_id : undefined
    initializeAnalytics(ga4Id)

    const initialTitle = typeof props.initialPage.props.page_title === 'string'
      ? props.initialPage.props.page_title
      : document.title
    trackPageView(props.initialPage.url, initialTitle)

    await syncPageLocale(props.initialPage)
    syncPageCsrfToken(props.initialPage)

    router.on('navigate', async (event) => {
      const pageTitle = typeof event.detail.page.props.page_title === 'string'
        ? event.detail.page.props.page_title
        : document.title
      trackPageView(event.detail.page.url, pageTitle)

      await syncPageLocale(event.detail.page)
      syncPageCsrfToken(event.detail.page)
    })

    const app = renderInertiaShell(App, props)

    if (el.hasChildNodes()) {
      hydrateRoot(el, app)
      return
    }

    createRoot(el).render(app)
  },
})